import Vue from 'vue';
import store from '@app/plugins/vuex';
import has from 'lodash-es/has';
import { getCookie, deleteCookie } from '@utils/cookie';
import i18n from '@app/plugins/i18n';

function checkReferrer() {
  let referredFromOldVersion = getCookie('refer') === 'old';
  if (referredFromOldVersion) {
    Vue.noty.show(i18n.t('shared.referrer.old_version'));
    deleteCookie('refer', { domain: '.zorra.com' });
  }
}

export function is_auth(from, to, next) {
  const id = from.query.id;
  const access_token = from.query.token;
  const isAuth = store['getters']['core/auth/is_auth'];

  checkReferrer();

  if (id && access_token) {
    store.commit(`core/auth/token`, access_token);
    store.commit(`core/auth/user`, { id });

    store
      .dispatch('core/auth/login', access_token)
      .then(() => {})
      .finally(() => {
        next();
      });
  } else {
    if (isAuth) {
      next();
    } else {
      next({ name: 'auth.login' });
    }
  }
}

export function is_not_auth(from, to, next) {
  const isAuth = store['getters']['core/auth/is_auth'];

  const isRedirectedFromCRM = has(from, 'query.service') ? from.query.service === 'crm' : false;
  const redirectedEmail = has(from, 'query.email') ? from.query.email : '';
  const currentEmail = has(isAuth, 'email') ? isAuth.email : '';

  const isIntegrated = isRedirectedFromCRM && !!redirectedEmail;
  const wantToIntegrate = isRedirectedFromCRM && from.path === '/register';

  if (isIntegrated) {
    if (isAuth && redirectedEmail === currentEmail) {
      next('');
    } else {
      next();
    }
  } else if (wantToIntegrate) {
    if (isAuth && redirectedEmail === currentEmail) {
      next('/');
    } else if (isAuth && redirectedEmail !== currentEmail) {
      store.dispatch('core/auth/logout').then(() => {
        if (!window.location.pathname.includes('auth/login')) {
          next();
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
}
